module.exports = __webpack_public_path__ + "static/assets/img/remote_events_flag.bfc1adf2.svg";